import APR from 'commons-general/constants/apr.js';

class AprService {
    displayApr(location, orgUnitId) {
        const isManitoba = APR.APR_LOCATIONS.includes(location);
        return isManitoba && !APR.APR_ORG_UNIT_IDS.includes(orgUnitId);
    }
}

export default new AprService();
